import wallet from '../../../assets/images/user-assets/wallet/wallet.png';

export const walletItems = [
    {
        "id" : 1,
        "walletName" : "MY WALLET",
        "walletImage" : wallet,
        "currencyType" : "AED",
        "price" : "45.78",
        "refundTitle" : "Refund",
        "refundAmount" : "0",
        "cashbackTitle" : "Cahback",
        "cashbackAmount" : "10.22",
        "bonusTitle" : "Bonus",
        "bonusAmount" : "1.1"

    }
]